/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Server_Soreness_TitleInputs */

const en_us2_push_server_soreness_title = /** @type {(inputs: Push_Server_Soreness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good morning`)
};

const pt_br2_push_server_soreness_title = /** @type {(inputs: Push_Server_Soreness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bom dia`)
};

const es_419_push_server_soreness_title = /** @type {(inputs: Push_Server_Soreness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buenos días`)
};

const pt_pt2_push_server_soreness_title = /** @type {(inputs: Push_Server_Soreness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bom dia`)
};

const fr_fr2_push_server_soreness_title = /** @type {(inputs: Push_Server_Soreness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour`)
};

const de_de2_push_server_soreness_title = /** @type {(inputs: Push_Server_Soreness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guten Morgen`)
};

const it_it2_push_server_soreness_title = /** @type {(inputs: Push_Server_Soreness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buongiorno`)
};

/**
* | output |
* | --- |
* | "Good morning" |
*
* @param {Push_Server_Soreness_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_server_soreness_title = /** @type {((inputs?: Push_Server_Soreness_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Server_Soreness_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_server_soreness_title(inputs)
	if (locale === "es-419") return es_419_push_server_soreness_title(inputs)
	if (locale === "pt-PT") return pt_pt2_push_server_soreness_title(inputs)
	if (locale === "fr-FR") return fr_fr2_push_server_soreness_title(inputs)
	if (locale === "de-DE") return de_de2_push_server_soreness_title(inputs)
	if (locale === "it-IT") return it_it2_push_server_soreness_title(inputs)
	return en_us2_push_server_soreness_title(inputs)
});
export { push_server_soreness_title as "push-server.soreness_title" }